/**
 * Module-cached "this boot is a ghost demo" flags, set by `bootDemo` BEFORE
 * React renders (same pattern as `setMobileUxForDemo` — never via localStorage,
 * which is shared with the host app on this origin).
 *
 * The calendar reads these to make demo playback deterministic and legible
 * under the host's CSS scale-down:
 * - hour gridlines are drawn thicker (a 1px line at ~0.5 iframe scale lands on
 *   fractional device pixels and intermittently disappears),
 * - the timed grid's initial scroll anchors on the script's fixtures instead of
 *   the wall clock, so the demo never has to scroll the calendar mid-run.
 */
let demo: { scrollHour: number } | null = null;
const demoQueryAtModuleLoad = (() => {
  try {
    return typeof window !== "undefined" && new URLSearchParams(window.location.search).has("demo");
  } catch {
    return false;
  }
})();

export function setDemoBoot(scrollHour: number): void {
  demo = { scrollHour };
}

export function isDemoBoot(): boolean {
  // Route modules (and their device-local stores) are imported before
  // `bootDemo()` gets a chance to call `setDemoBoot`. Detect the query at that
  // earlier module-initialization point so a demo cannot even read host-local
  // presentation state on its shared origin.
  return demo !== null || demoQueryAtModuleLoad;
}

/** Hour (0-23) the demo grid should scroll to on mount; null outside demos. */
export function demoScrollHour(): number | null {
  return demo?.scrollHour ?? null;
}
